import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http'
import {ConfigService} from '../config/config.service'

@Injectable({
  providedIn: 'root'
})
export class ObservableApiService {
  baseUrl: string;

  constructor(
    private http: HttpClient,
    private config: ConfigService,
  ) {
    const apiSettings = config.get('api');
    this.baseUrl      = apiSettings['proto'] + '://' + apiSettings['host'] + '/';
  }

  public get(url: string) {
    return this.http.get(this.baseUrl + url);
  }
}
